/**
 * Patient billing addresses — `/api/v2/invoicing/billing-addresses/*`.
 * The invoice country/address authority. NOTE: updates use PATCH.
 */
import instance, { ADMIN_PREFIX } from 'services/api';
import {
  BillingAddress,
  BillingAddressInput,
  UpdateBillingAddressInput
} from 'types/api/invoicing';

const BASE = `${ADMIN_PREFIX}/invoicing/billing-addresses`;

/** `GET /invoicing/billing-addresses?patientId=` — a patient's addresses (array). */
export const fetchBillingAddresses = async (
  patientId: number
): Promise<BillingAddress[]> => {
  const res = await instance.get<BillingAddress[]>(BASE, {
    params: { patientId }
  });

  return res.data ?? [];
};

/** `POST /invoicing/billing-addresses` — create for a patient. */
export const createBillingAddress = (input: BillingAddressInput) =>
  instance.post<BillingAddress>(BASE, input);

/** `PATCH /invoicing/billing-addresses/:publicId` — update. */
export const updateBillingAddress = (
  publicId: string,
  input: UpdateBillingAddressInput
) => instance.patch<BillingAddress>(`${BASE}/${publicId}`, input);
